import React, { useState, useEffect } from "react";
import cssLogin from "../common.module.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomImageContainer from "../../../components/common/CustomImageContainer.jsx";
import SignUpImg from "../../../assets/forgotPassword.svg";
import Starfor from "../../../assets/StarForLogo.svg";
import Text from "../../../components/typography/Text/index.jsx";
import { errorToast, successToast, warnToast } from "../../../utils/toasts.jsx";
import { Link, useNavigate } from "react-router-dom";
import Grid from "../../../components/layout/grid/Grid";
import CustomTextInput from "../../../components/common/CustomTextInput";
import { EyeIcon } from "hugeicons-react";
import CustomButton from "../../../components/common/CustomButton/CustomButton";
import { EyeSlashIcon } from "@heroicons/react/16/solid";
import { MdEmail, MdLock, MdSms } from "react-icons/md";
import { IconContext } from "react-icons/lib";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const loginSchema = Yup.object().shape({
        email: Yup.string().email("Invalid email").required("Required"),

    });
    const OnSubmit = async (values, { setSubmitting, setErrors }) => {
        const data = {
            email: values.email,

        };
        console.log("login data ", data);
        // navigate('/');
    };

    return (
        <section className=" w-full h-screen flex flex-1 bg-white">
            <div className="flex flex-row justify-between w-full" >
                <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                    <div className={cssLogin.cardwidth}>
                        <div className="p-6 space-y-4 md:space-y-6 sm:p-8 flex flex-col items-center justify-center w-[100%]">
                            <div className="flex gap-6 w-full items-start">
                                <div className="flex flex-col items-start justify-center w-full ">
                                    <div className="flex justify-start items-start   h-full w-full mb-7">
                                        <CustomImageContainer src={Starfor} />
                                    </div>

                                    <Text variant="h3-title" className="mt-0 !text-blue-900 !text-left">
                                        Forgot Password?{" "}
                                    </Text>
                                    <p className="text-[#282828] text-base font-[500] mt-2">
                                        Enter your user account's verified email address and we will send you a password reset link.
                                    </p>
                                </div>
                            </div>
                            <div className=" w-full">
                                <Formik
                                    initialValues={{
                                        email: "",

                                    }}
                                    validationSchema={loginSchema}
                                    onSubmit={OnSubmit}
                                >
                                    {({ isValid, isSubmitting }) => (
                                        <Form>
                                            <Grid xs={12} md={12} >
                                                <Grid item xs={12} md={12}>
                                                    <CustomTextInput
                                                        name={"email"}
                                                        label={"Email id"}
                                                        placeholder={"enter your email"}
                                                        endIconBg={true}
                                                        endIcon={
                                                            <MdEmail />
                                                        }
                                                    />
                                                </Grid>


                                                <Grid item xs={12}>
                                                    <CustomButton
                                                        style={{
                                                            width: "100%",
                                                        }}
                                                        label={"Next"}
                                                        size={"md"}
                                                        type={"submit"}
                                                        isLoading={isSubmitting}
                                                        disabled={!isValid || isSubmitting}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-center  mx-auto md:h-screen lg:py-0 bg-white w-full">
                    <CustomImageContainer src={SignUpImg} width={"70%"} height={"70%"} />
                </div>
            </div>
        </section>
    );
}

